import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { Home, FileText, Truck, Map, Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './MobileNav.css';

function MobileNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useAuth();

  const isActive = (path: string) => location.pathname === path;

  const items = [
    { path: '/', label: t('nav.dashboard'), icon: <Home size={20} /> },
    { path: '/requests', label: t('nav.requests'), icon: <FileText size={20} /> },
    { path: '/missions', label: t('nav.missions', 'Missions'), icon: <Truck size={20} /> },
    { path: '/map', label: t('nav.map'), icon: <Map size={20} /> },
    { path: '/notifications', label: t('nav.notifications'), icon: <Bell size={20} /> },
  ];

  return (
    <nav className="mobile-nav">
      {items.map(item => (
        <Link
          key={item.path}
          to={item.path}
          className={`mobile-nav-item ${isActive(item.path) ? 'active' : ''}`}
        >
          <span className="mobile-nav-icon">{item.icon}</span>
          <span className="mobile-nav-label">{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default MobileNav;
